import { differenceInMilliseconds, hoursToMinutes, minutesToMilliseconds } from "date-fns";

export const formatTimeForPractice = (hour?: string, start?: Date) => {
  if(!hour || !start) {
    return undefined;
  }

  if(hour && start) {
    const hourSplit = hour.split(":");
    const minutes = hoursToMinutes(Number(hourSplit[0])) + Number(hourSplit[1]);
    const miliseconds = minutesToMilliseconds(minutes);
    const difference = differenceInMilliseconds(new Date(), new Date(start));
    const finalTime = miliseconds - difference;

    return finalTime > 0 ? finalTime : 0;
  }

  return 0;
}